import React from "react";
import DOMPurify from "dompurify";

const WelcomeSection = ({ data }) => {
  // Agar data na ho to render na karein
  if (!data?.welcome_section) return null;

  const welcome = data.welcome_section;

  // Title split logic (e.g., "Sky47 Cloud" -> Black "Sky47" and Blue "Cloud")
  const renderTitle = (fullTitle) => {
    if (!fullTitle) return null;
    const words = fullTitle.split(" ");
    if (words.length > 1) {
      const firstPart = words[0];
      const secondPart = words.slice(1).join(" ");
      return (
        <>
          {firstPart} <span className="sky-ws-highlight">{secondPart}</span>
        </>
      );
    }
    return fullTitle;
  };

  return (
    <>
      <section className="sky-ws-banner-bar scalable_secure_section brr-none border-0 mt-5">
        <div className="container">
          <h2
            className="sky-ws-main-heading text-center"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(welcome.content_below_heading),
            }}
          />
          {welcome.content_below_description && (
            <p
              className="sky-ws-description text-center "
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(welcome.content_below_description),
              }}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default WelcomeSection;
